import { useQuery } from '@apollo/client';
import type { CommunityOptions } from '@communities/community/domain';
import { GET_COMMUNITY_OPTIONS } from '@communities/community/graphql';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface CommunityOptionsResponse {
  communityOptions: CommunityOptions;
}

export function useCommunityOptions() {
  const { data, loading, error } = useQuery<CommunityOptionsResponse>(GET_COMMUNITY_OPTIONS, {});

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  return {
    genres: data?.communityOptions.contentGenres || [],
    contentRatings: data?.communityOptions.pgRatings || [],
    loading,
    errors,
  };
}

export default useCommunityOptions;
